/**
 * The platform default for how many agent runs one workspace may have going
 * at once, when a superadmin has not set `workspaces.max_concurrent_runs`.
 * Extra work waits its turn and starts on its own when a slot frees.
 */
export const DEFAULT_WORKSPACE_MAX_CONCURRENT_RUNS = 3;
/** The largest per-workspace concurrency cap a superadmin may set. */
export const WORKSPACE_MAX_CONCURRENT_RUNS_LIMIT = 100;
/**
 * The server-set `llm_usage.agent_id` grain of each named Worker that bills
 * the rate card, mapped to its Worker registry slug. The one source of truth
 * for which `agent_id` means which Worker on the Usage report: the backend's
 * allowlist (`billing/workerUsageRateCard.ts`) and the admin panel's link from
 * a Worker row to its customer drill both read it.
 */
export const YAGNI_CODE_WORKER_AGENT_SLUGS = {
    code_review: "proctor",
    reeve: "reeve",
    fletcher: "fletcher",
    desk_brief: "harper",
    proposal_lane: "bailey",
};
//# sourceMappingURL=yagniCode.js.map